import { render, staticRenderFns } from "./i-post.vue?vue&type=template&id=ece1e3b4&scoped=true&"
import script from "./i-post.vue?vue&type=script&lang=js&"
export * from "./i-post.vue?vue&type=script&lang=js&"
import style0 from "./i-post.vue?vue&type=style&index=0&id=ece1e3b4&lang=css&scoped=true&"
import style1 from "./i-post.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece1e3b4",
  null
  
)

export default component.exports